// extracted by mini-css-extract-plugin
module.exports = {"error":"_2ab2edf","errorIcon":"_eba777f"};